import { FontEnum } from '@/constants/font'
import { logger } from '@/logger'
import { useFonts } from 'expo-font'
import { useEffect } from 'react'

export const useAssetsFonts = (): void => {
    const [_, error] = useFonts({
        [FontEnum.SatoshiBold]: require('@/assets/fonts/Satoshi-Bold.otf'),
        [FontEnum.SatoshiLight]: require('@/assets/fonts/Satoshi-Light.otf'),
        [FontEnum.SatoshiMedium]: require('@/assets/fonts/Satoshi-Medium.otf'),
        [FontEnum.SatoshiRegular]: require('@/assets/fonts/Satoshi-Regular.otf'),
    })

    useEffect(() => {
        if (error) logger.errorOnly(error)
    }, [error])
}
